import { h } from "preact";
import {Button, Table, Tag} from "antd";
import { useNavigate } from "react-router-dom";
import {LeftOutlined, RightOutlined} from "@ant-design/icons";

export const ConsumersTable = ({ consumers, loading, pagination, onPrevPage, onNextPage }) => {
    const navigate = useNavigate();

    const handleConsumerClick = (consumerId) => {
        navigate(`/consumers/${consumerId}`);
    };

    const columns = [
        {
            title: "Consumer ID",
            dataIndex: "consumer_id",
            key: "consumer_id",
            render: (text) => (
                <a
                    style={{ color: "#1890ff", cursor: "pointer" }}
                    onClick={() => handleConsumerClick(text)}
                >
                    {text}
                </a>
            ),
            sorter: (a, b) => a.consumer_id.localeCompare(b.consumer_id),
        },
        {
            title: "Username",
            dataIndex: "username",
            key: "username",
            sorter: (a, b) => a.username.localeCompare(b.username),
        },
        {
            title: "Organization",
            dataIndex: "company",
            key: "company",
            sorter: (a, b) => {
                const companyA = a.company || "";
                const companyB = b.company || "";
                return companyA.localeCompare(companyB);
            },
        },
        {
            title: "Location",
            key: "location",
            render: (_, record) => {
                const country = record.country || "null";
                const city = record.city || "null";
                const address = record.address || "null";

                return (
                    <span>{country}, {city}, {address}</span>
                );
            },
        },
        {
            title: "Status",
            dataIndex: ["status", "status"],
            key: "status",
            render: (status) => (
                <Tag color={status === "active" ? "green" : "red"}>
                    {status?.toUpperCase() || "UNKNOWN"}
                </Tag>
            ),
        },
        {
            title: "Created at",
            dataIndex: "created_at",
            key: "created_at",
            render: (text) => {
                const date = new Date(text);
                return date.toLocaleString();
            },
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
        },
    ];

    const CustomPagination = () => (
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 0",
            borderTop: "1px solid #f0f0f0"
        }}>
            <div>
                Page {pagination.current} • {consumers.length} consumers shown
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
                <Button
                    icon={<LeftOutlined />}
                    onClick={onPrevPage}
                    disabled={!pagination.hasPrev || loading}
                >
                    Previous
                </Button>
                <Button
                    icon={<RightOutlined />}
                    onClick={onNextPage}
                    disabled={!pagination.hasNext || loading}
                >
                    Next
                </Button>
            </div>
        </div>
    );

    return (
        <div>
            <Table
                dataSource={consumers}
                columns={columns}
                rowKey="consumer_id"
                loading={loading}
                pagination={false}
                scroll={{ x: true }}
                bordered
                className="consumers-table"
            />
            <CustomPagination />
        </div>
    );
};